import { useEffect, useRef, useState } from "react";
import styles from "./countUpFunction.module.scss";

const useCountUpOnView = (start, end, duration = 2000) => {
  const [count, setCount] = useState(start);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          let current = start;
          const frameRate = 16;
          const steps = duration / frameRate;
          const increment = (end - start) / steps;

          const interval = setInterval(() => {
            current += increment;
            if (current >= end) {
              setCount(end);
              clearInterval(interval);
            } else {
              setCount(Math.round(current));
            }
          }, frameRate);

          setHasAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [start, end, duration, hasAnimated]);

  return { count, ref };
};

export const AnimatedNumber = ({ start, end, duration, suffixType }) => {
  const { count, ref } = useCountUpOnView(start, end, duration);

  const formatNumber = (num) => {
    if (suffixType === "million") {
      return `₹ ${(num / 1_000_000).toFixed(1)} + M`;
    }
    return num.toString();
  };

  return (
    <div
      ref={ref}
      className={styles.counterText}
    >
      {formatNumber(count)}
    </div>
  );
};
